'use strict';

import { AnimationClip, AnimationMixer, FileLoader, KeyframeTrack, Matrix4, Object3D, Quaternion, Vector3 } from 'three';
import { setAnimations } from '../post-processing/post-processing';
import {resourcesFolder, settingsData, threeJsVariables} from "../../settings";
import {Cloudflare} from "../api/Cloudflare";
import { ViewMode } from '../../common';

let animations = null;
let loader = null;

const matrix = new Matrix4();

export class AnimateObject {
    constructor (object,animation) {
        
        const shadow = threeJsVariables.quality.castShadowForAnimatedObjects();
        object.traverse(el => {
            if (el.isMesh) {
                el.castShadow = shadow;
                el.receiveShadow = shadow;
            }
        });
        
        this.object = object;
        this.animation = animation;

        if (typeof animation === 'string') {
            this.setAnimations();
        } else {
            const clip = AnimationClip.parse(this.animation);
            setAnimations(this.object,[clip]);
        }
    }

    async setAnimations() {
        if (!animations) {
            loader = new FileLoader();
            animations = await this.loadAnimations();
        }

        const animation = animations[this.animation];
        if (animation) {
            const splitName = this.animation.split('::');
            let instanceId = null;
            if (splitName.length > 1) {
                instanceId = Number(splitName[1]);
            }
            const clip = AnimationClip.parse(animation);
            setAnimations(this.object,[clip],instanceId);
        }
    }

    loadAnimations() {
        const url = `${config.cdnRepository}/${config.projectFolder}/${resourcesFolder}/sceneObjects/animations.json?v=${Cloudflare.version}`;

        return new Promise(resolve => {
            loader.load(url,file => {
                resolve(JSON.parse(file));
            },undefined,() => {
                resolve({});
            });
        });
    }
}

export class AnimationObject extends AnimationMixer {
    constructor (object,instanceId) {

        let instanceObject = null;

        if (object.isInstanceLODObject || object.isInstancedMesh) {
            instanceObject = object;
            object.getMatrixAt(instanceId, matrix);
            object = new Object3D();
            object.position.setFromMatrixPosition(matrix);
            object.quaternion.setFromRotationMatrix(matrix);
            object.scale.setFromMatrixScale(matrix);
        }

        super(object);

        this.instanceObject = instanceObject;
        this.instanceId = instanceId;
    }

    update(delta) {
        super.update(delta);
        if (this.instanceObject) {
            this.getRoot().updateMatrixWorld();
            this.instanceObject.setMatrixAt(this.instanceId,this.getRoot().matrix);
            if (this.instanceObject.isInstancedMesh) {
                this.instanceObject.instanceMatrix.needsUpdate = true;
                this.instanceObject.computeBoundingSphere();
            }else if (this.instanceObject.isInstanceLODObject) {
                this.instanceObject.instancesLevels.forEach((level) => {
                    level.mesh.computeBoundingSphere();
                });
            }
        }
        // if (settingsData.activeViewMode === ViewMode.Orbit) {
        //     threeJsVariables.renderer.shadowMap.needsUpdate = true;
        // }
    }
}
